module.exports = __webpack_public_path__ + "img/icon-indice-cronologico2.03583880.png";